<form [formGroup]="contactForm" (ngSubmit)="contactDialogSubmit()">
  <div
    class="form-group required-field"
    [ngClass]="{
      'p-invalid':
        contactForm.get('contactType')?.invalid &&
        (contactForm.get('contactType')?.touched ||
          contactForm.get('contactType')?.dirty)
    }"
  >
    <p-floatLabel variante="in">
      <p-dropdown
        [options]="contactTypes"
        name="contactType"
        optionLabel="contactTypeName"
        optionValue="contactTypeId"
        [showClear]="true"
        formControlName="contactType"
      >
      </p-dropdown>
      <label> Art des Kontakts*</label>
    </p-floatLabel>
  </div>

  <div
    *ngIf="!contactForm.get('participant')?.disabled"
    class="form-group required-field"
    [ngClass]="{
      'p-invalid':
        contactForm.get('participant')?.invalid &&
        (contactForm.get('participant')?.touched ||
          contactForm.get('participant')?.dirty)
    }"
  >
    <p-floatLabel variante="in">
      <p-dropdown
        [options]="participants"
        id="participant"
        [filter]="true"
        filterBy="fullName"
        name="participant"
        optionLabel="fullName"
        optionValue="userId"
        [showClear]="true"
        formControlName="participant"
      >
      </p-dropdown>
      <label>Teilnehmer:in/Interessent:in*</label>
    </p-floatLabel>

    <button
      pButton
      type="button"
      title="Teilnehmer:in/Interessent:in anlegen"
      label="Teilnehmer:in/Interessent:in anlegen"
      icon="pi pi-plus"
      class="p-button-text"
      (click)="showAddLeadDialog()"
    ></button>
  </div>

  <!-- Datum -->
  <div class="form-group">
    <p-floatLabel variante="in">
      <p-calendar
        inputId="contactDate"
        formControlName="contactDate"
        name="contactDate"
        dateFormat="dd.mm.yy"
        showIcon="true"
        required
      ></p-calendar>
      <label for="contactDate">Datum*</label>
    </p-floatLabel>
  </div>

  <!-- Uhrzeit -->
  <div
    class="form-group required-field"
    [ngClass]="{
      'p-invalid':
        contactForm.get('contactTime')?.invalid &&
        (contactForm.get('contactTime')?.touched ||
          contactForm.get('contactTime')?.dirty)
    }"
  >
    <p-floatLabel variante="in">
      <input
        pInputText
        id="contactTime"
        type="time"
        formControlName="contactTime"
        name="contactTime"
        timeOnly="true"
        hourFormat="24"
        required
      />
      <label for="contactTime">Uhrzeit*</label>
    </p-floatLabel>
  </div>

  <!-- Dauer -->
  <div
    class="form-group required-field"
    [ngClass]="{
      'p-invalid':
        contactForm.get('duration')?.invalid &&
        (contactForm.get('duration')?.touched ||
          contactForm.get('duration')?.dirty)
    }"
  >
    <p-floatLabel variante="in">
      <input
        pInputText
        formControlName="duration"
        id="duration"
        name="duration"
        type="time"
        timeOnly="true"
        hourFormat="24"
        placeholder="Dauer auswählen"
      />
      <label for="duration">Dauer*</label>
    </p-floatLabel>
  </div>

  <!-- Kontakt durch -->
  <div
    class="p-field required-field"
    [ngClass]="{
      'p-invalid':
        contactForm.get('contactBy')?.invalid &&
        (contactForm.get('contactBy')?.touched ||
          contactForm.get('contactBy')?.dirty)
    }"
  >
    <label for="contactBy">Kontakt durch*</label>
    <input
      id="contactBy"
      type="text"
      formControlName="contactBy"
      name="contactBy"
      [readonly]="true"
    />
  </div>

  <div class="form-group">
    <label>Bemerkungen</label>
    <p-editor formControlName="remarks" />
  </div>

  <!-- #region FILE DROP COMPONENT -->

  <app-filedrop
    bucketname="contacts"
    (fileUploadStarted)="onFileUploadStarted()"
    (fileUploadCompleted)="onFilesUploaded($event)"
  >
  </app-filedrop>

  <!-- #endregion -->

  <p>(* Pflichtfelder)</p>

  <div class="form-buttons">
    <button
      pButton
      label="Speichern"
      title="Speichern"
      icon="pi pi-save"
      type="submit"
      class="p-button-success"
      [disabled]="!contactForm.valid || isSubmitting"
    ></button>
    <button
      pButton
      title="Abbrechen"
      type="button"
      label="Abbrechen"
      icon="pi pi-times"
      class="p-button-secondary"
      (click)="closeDialog()"
    ></button>
  </div>
</form>
